import { ChartData } from '../types';
import Icon from '../../../components/AppIcon';

interface TaxDistributionChartProps {
  data: ChartData[];
  title: string;
  type: 'bar' | 'pie';
}

const TaxDistributionChart = ({ data, title, type }: TaxDistributionChartProps) => {
  const maxValue = Math.max(...data.map(d => d.value));

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const calculatePercentage = (value: number) => {
    const total = data.reduce((sum, item) => sum + item.value, 0);
    return ((value / total) * 100).toFixed(1);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <Icon name="BarChart3" size={20} color="var(--color-primary)" />
      </div>

      {type === 'bar' && (
        <div className="space-y-4">
          {data.map((item, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-foreground">{item.label}</span>
                <span className="text-sm font-mono text-muted-foreground">
                  {formatCurrency(item.value)}
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-3 overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{
                    width: `${(item.value / maxValue) * 100}%`,
                    backgroundColor: item.color
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {type === 'pie' && (
        <div className="space-y-3">
          {data.map((item, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-muted rounded-md">
              <div className="flex items-center gap-3">
                <div
                  className="w-4 h-4 rounded-full flex-shrink-0"
                  style={{ backgroundColor: item.color }}
                />
                <span className="text-sm font-medium text-foreground">{item.label}</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-sm font-mono text-muted-foreground">
                  {formatCurrency(item.value)}
                </span>
                <span className="text-sm font-semibold text-primary font-mono">
                  {calculatePercentage(item.value)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TaxDistributionChart;